<template>
    <div>

        <v-layout row justify-center>
            <v-dialog v-model="dialog" max-width="290" :persistent="true">
                <v-card>
                    <v-card-title class="headline">Localização</v-card-title>
                    <v-card-text>Cliente sem localização, pretende cadastrar a localização neste momento?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Não</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="openLatLong">Quero Cadastrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row justify-center>
            <v-dialog v-model="dialogFrustrada" max-width="290" :persistent="true">
                <v-card>
                    <v-card-title class="headline">Localização</v-card-title>
                    <v-card-text>Cliente sem localização, pretende cadastrar a localização neste momento?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Não</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="openLatLong">Quero Cadastrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-flex xs12>

            <main >

                <v-layout row pa-2 v-if="(!ordem.latlng || !ordem.latlng.latitude)" style="margin-top: 5px">
                    <v-flex xs12  sm6 offset-sm3>
                        <v-chip color="red" text-color="white" style="width: 100%" >
                            <v-avatar>
                                <v-icon>pin_drop</v-icon>
                            </v-avatar>
                            SEM LAT E LONG
                        </v-chip>
                    </v-flex>
                </v-layout>

                <v-layout pa-2 row v-if="ordem.data_agendamento">
                    <v-flex xs12 sm6 offset-sm3>
                        <v-chip color="green" text-color="white" style="width: 100%" >
                            <v-avatar>
                                <v-icon>access_time</v-icon>
                            </v-avatar>
                            {{ordem.data_agendamento | date('DD/MM/YYYY HH:mm:ss')}}
                        </v-chip>
                    </v-flex>
                </v-layout>

                <v-layout pa-2 row>
                    <v-flex xs12 sm6 offset-sm3>
                        <v-card style="margin-top: 5px" class="elevation-0">
                            <v-card-title class="indigo">
                                <span class="white--text">{{ordem.cliente.nome}}</span>
                            </v-card-title>
                            <v-list three-line>

                                <v-list-tile v-if="ordem.cod_cliente">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Código do Cliente
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            {{ordem.cod_cliente}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider v-if="ordem.cod_cliente"></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Cidade
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            {{ordem.street.cidade}} - {{ordem.street.estado}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Bairro
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>
                                            {{ordem.street.bairro}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Endereço</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.street.endereco}}, {{ordem.street.numero}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile v-if="ordem.street.complemento">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Complemento</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.street.complemento}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                            </v-list>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout pa-2 row v-if="ordem.telefones" >
                    <v-flex xs12 sm6 offset-sm3>
                        <v-card class="elevation-0">

                            <v-card-title class="indigo">
                                <span class="white--text">TELEFONE</span>
                            </v-card-title>

                            <v-list>

                                <template>
                                    <v-list-tile v-for="tel of ordem.telefones" :key="tel.numero">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{tel.numero}}</v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <a :href="'tel:' + tel.numero ">
                                                <v-icon :color="'teal'">phone</v-icon>
                                            </a>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <v-divider/>
                                </template>

                            </v-list>

                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <v-flex pa-2 xs12 sm6 offset-sm3>
                        <v-card v-if="ordem.dados_internet" class="elevation-0">

                            <v-card-title class="indigo">
                                <span class="white--text">DADOS DA INTERNET</span>
                            </v-card-title>

                            <v-list>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Usuário</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.dados_internet.usuario}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Senha</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.dados_internet.senha}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Download / Upload</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.dados_internet.download / 1024}}MB / {{ordem.dados_internet.upload / 1024}}MB</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider></v-divider>

                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Tipo de Internet</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.tipo_internet}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider v-if="ordem.caixa"></v-divider>

                                <v-list-tile v-if="ordem.caixa">
                                    <v-list-tile-content>
                                        <v-list-tile-title>CAIXA</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ordem.caixa.nome}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                            </v-list>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout pa-2 row v-if="ordem.obs">
                    <v-flex xs12 sm6 offset-sm3>
                        <v-flex xs12 >
                            <v-card color="blue-grey darken-2" flat class="white--text">
                                <v-card-title primary-title>
                                    <div>{{ordem.obs}}</div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <div v-if="ordem.instalacao">
                    <list-produtos :produtos="ordem.produtos" v-if="ordem.produtos && ordem.produtos.length"/>

                    <v-layout pa-2 row>
                        <v-flex xs12 sm6 offset-sm3>
                            <v-chip color="indigo" text-color="white" style="width: 100%" v-if="!ordem.produtos || !ordem.produtos.length">
                                <v-avatar>
                                    <v-icon>list</v-icon>
                                </v-avatar>
                                NENHUM PRODUTO
                            </v-chip>
                        </v-flex>
                    </v-layout>
                </div>

                <div v-if="ordem.produto_retirar">
                    <list-produtos :title="'PRODUTOS PARA RETIRAR'" :produtos="ordem.produto_retirar" />
                </div>

                <div v-if="!ordem.instalacao">
                    <list-problemas :problemas="ordem.problemas" v-if="ordem.problemas && ordem.problemas.length"/>

                    <v-layout pa-2 row>
                        <v-flex xs12 sm6 offset-sm3>
                            <v-chip color="indigo" text-color="white" style="width: 100%" v-if="!ordem.problemas || !ordem.problemas.length">
                                <v-avatar>
                                    <v-icon>list</v-icon>
                                </v-avatar>
                                NENHUM PROBLEMA
                            </v-chip>
                        </v-flex>
                    </v-layout>

                </div>

            </main>
        </v-flex>

    </div>
</template>

<script>
    import ListProdutos from "./ListProdutos";
    import ListProblemas from "./ListProblemas";
    import { date } from "../../filters";
    export default {
        name: "dados-ordem",
        filters: {
            date
        },
        props: {
            ordem: {
                default: null
            }
        },
        data () {
            return {
                dialog: false,
                dialogFrustrada: false
            };
        },
        components: {
            ListProdutos, ListProblemas
        }
    };
</script>

<style scoped>

</style>
